/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from "react";
import "./styles.scss";
import Loader from "../../../components/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getSingalClassroomData } from "../../../utils/classrooms";
import {
  // getTopicsMastery,
  // getTopicsMasteryBySubjects,
} from "../../../utils/mastery";
import {
  getTopRecommendations,
  getTopRecommendationsBySubjects,
} from "../../../utils/recommendations";
import { getGrowthProgress } from "../../../utils/growth";
// import TopicsNearMastery from "./Diagnostic/components/TopicsNearMastery/index";
import Recommendations from "./Diagnostic/components/Recommendations/index";
import GrowthProgress from "./Diagnostic/components/GrowthProgress/index";
import SubjectFilter from "./Diagnostic/components/SubjectFilter/index";
import RecommendationsGuide from "./Diagnostic/RecomendationsGuide";
// import { getColorForScore } from "./Diagnostic/utils";

const Diagnostic = ({ classroomId, studentId }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState("mastery");
  const [subjects, setSubjects] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  // const [topicsData, setTopicsData] = useState([]);
  // const [topicsNearMastery, setTopicsNearMastery] = useState([]);
  const [recommendationsData, setRecommendationsData] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [growthData, setGrowthData] = useState({
    basic: { count: 0, topics: [] },
    inProgress: { count: 0, topics: [] },
    mastered: { count: 0, topics: [] },
  });
  const [filteredGrowthData, setFilteredGrowthData] = useState(growthData);

  // Fetch classroom details to get subjects
  useEffect(() => {
    const getClassroomDetails = async () => {
      try {
        const response = await getSingalClassroomData(classroomId);
        if (response?.data?.classRoom?.course?.subjects) {
          setSubjects(response.data.classRoom.course.subjects);
        }
      } catch (error) {
        console.error("Error fetching classroom details:", error);
        toast.error("Failed to load classroom details");
      }
    };

    if (classroomId) {
      getClassroomDetails();
    }
  }, [classroomId]);

  // Fetch mastery data
  // useEffect(() => {
  //   const fetchMasteryData = async () => {
  //     try {
  //       setLoading(true);
  //       let response;

  //       if (filteredSubjects.length > 0) {
  //         response = await getTopicsMasteryBySubjects(
  //           classroomId,
  //           filteredSubjects,
  //           studentId
  //         );
  //       } else {
  //         response = await getTopicsMastery(classroomId, studentId);
  //       }

  //       if (response.ok) {
  //         const masteryData = response.data;
  //         const transformedTopics = masteryData.topics.map((topic, index) => ({
  //           id: topic._id,
  //           name: topic.name,
  //           score: parseFloat(String(topic.score).replace("%", "")),
  //           color: getColorForScore(
  //             parseFloat(String(topic.score).replace("%", ""))
  //           ),
  //           angle: (index * 72) % 360,
  //           subjectId: topic.subjectId,
  //           examId: topic.examId,
  //           unAttemptedPractices: topic.unAttemptedPractices || [],
  //           unAttemptedTests: topic.unAttemptedTests || [],
  //           attemptedPractices: topic.latestPracticesDone || [],
  //           attemptedTests: topic.latestTestsDone || [],
  //           resources: [
  //             ...(topic.unAttemptedPractices || []).map((practice) => ({
  //               id: practice._id,
  //               name: practice.name,
  //               examType: practice.type,
  //               type: "practice",
  //             })),
  //             ...(topic.unAttemptedTests || []).map((test) => ({
  //               id: test._id,
  //               examType: test.type,
  //               name: test.name,
  //               type: "test",
  //             })),
  //           ],
  //         }));

  //         setTopicsData(transformedTopics);
  //         updateFilteredTopics(transformedTopics);
  //       } else {
  //         toast.error("Failed to load mastery data");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching mastery data:", error);
  //       toast.error("Failed to load mastery data");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (classroomId) {
  //     fetchMasteryData();
  //   }
  // }, [classroomId, filteredSubjects, studentId]);

  // Fetch top recommendations
  useEffect(() => {
    const fetchTopRecommendations = async () => {
      try {
        setLoading(true);
        let response;

        if (filteredSubjects.length > 0) {
          response = await getTopRecommendationsBySubjects(
            classroomId,
            filteredSubjects,
            studentId
          );
        } else {
          response = await getTopRecommendations(classroomId, studentId);
        }

        if (response.ok) {
          const recommendationsData = response.data.topics;
          const transformedRecommendations = recommendationsData.map(
            (topic) => {
              const score = parseFloat(topic.score);
              return {
                _id: topic._id,
                name: topic.name,
                score: score,
                subjectId: topic.subjectId,
                attemptedPractices: topic.attemptedPractices || [],
                attemptedTests: topic.attemptedTests || [],
                unAttemptedPractices: topic.unAttemptedPractices || [],
                unAttemptedTests: topic.unAttemptedTests || [],
              };
            }
          );

          setRecommendationsData(transformedRecommendations);
          setRecommendations(transformedRecommendations);
        } else {
          toast.error("Failed to load recommendations");
        }
      } catch (error) {
        console.error("Error fetching recommendations:", error);
        toast.error("Failed to load recommendations");
      } finally {
        setLoading(false);
      }
    };

    if (classroomId) {
      fetchTopRecommendations();
    }
  }, [classroomId, filteredSubjects, studentId]);

  // Fetch growth progress data
  useEffect(() => {
    const fetchGrowthProgress = async () => {
      try {
        setLoading(true);
        const response = await getGrowthProgress(classroomId, studentId);

        if (response.ok) {
          setGrowthData(response.data);
          setFilteredGrowthData(response.data);
        } else {
          toast.error("Failed to load growth progress data");
        }
      } catch (error) {
        console.error("Error fetching growth progress:", error);
        toast.error("Failed to load growth progress data");
      } finally {
        setLoading(false);
      }
    };

    if (classroomId) {
      fetchGrowthProgress();
    }
  }, [classroomId, studentId]);

  const isValidScore = (score) => {
    if (typeof score === "string") {
      score = score.trim();
    }
    return (
      score !== null &&
      score !== undefined &&
      score !== "null" &&
      score !== "undefined" &&
      !isNaN(Number(score))
    );
  };

  // const isChampion = (topic) => {
  //   // Check all practices
  //   const allPracticesAttempted =
  //     !topic.unAttemptedPractices?.length &&
  //     (topic.attemptedPractices || []).every((p) => isValidScore(p.score));
  //   // Check all tests
  //   const allTestsAttempted =
  //     !topic.unAttemptedTests?.length &&
  //     (topic.attemptedTests || []).every((t) => isValidScore(t.score));
  //   // Check topic score
  //   const scoreNum = Number(topic.score);
  //   return allPracticesAttempted && allTestsAttempted && scoreNum >= 90;
  // };

  // const updateFilteredTopics = (topics) => {
  //   let filtered = topics.filter((topic) => !isChampion(topic));
  //   if (filteredSubjects.length > 0) {
  //     filtered = filtered.filter((topic) =>
  //       filteredSubjects.includes(topic.subjectId)
  //     );
  //   }
  //   filtered = filtered.sort((a, b) => b.score - a.score).slice(0, 5);
  //   const chartData = filtered.map((topic, index) => ({
  //     ...topic,
  //     angle: (index * 72) % 360,
  //   }));
  //   setTopicsNearMastery(chartData);
  // };

  const updateFilteredGrowthData = (data) => {
    if (filteredSubjects.length > 0) {
      const filteredGrowth = {
        basic: { count: 0, topics: [] },
        inProgress: { count: 0, topics: [] },
        mastered: { count: 0, topics: [] },
      };

      Object.entries(data).forEach(([category, categoryData]) => {
        const filteredTopics = categoryData.topics.filter((topic) =>
          filteredSubjects.includes(topic.subjectId)
        );
        filteredGrowth[category] = {
          count: filteredTopics.length,
          topics: filteredTopics,
        };
      });

      setFilteredGrowthData(filteredGrowth);
    } else {
      setFilteredGrowthData(data);
    }
  };

  const handleFilterChange = (subjectId) => {
    if (Array.isArray(subjectId)) {
      setFilteredSubjects([]);
    } else {
      setFilteredSubjects((prevSelected) => {
        const isSelected = prevSelected.includes(subjectId);
        return isSelected
          ? prevSelected.filter((id) => id !== subjectId)
          : [...prevSelected, subjectId];
      });
    }
  };

  // Update filtered data when filteredSubjects changes
  useEffect(() => {
    // if (topicsData.length > 0) {
    //   updateFilteredTopics(topicsData);
    // }
    if (recommendationsData.length > 0) {
      updateFilteredGrowthData(growthData);
    }
  }, [filteredSubjects]);

  const handleResourceClick = (resource, topic) => {
    if (resource.type === "practice") {
      const attemptType = resource?.examType === "writing"
        ? "writingAttempt"
        : resource?.examType === "speaking"
          ? "speakingAttempt"
          : "practiceAttempt"
      navigate(
        `/student/myClassrooms/${classroomId}/${topic.subjectId}/${topic.id}/practice/${attemptType}/${resource.id}`
      );
    } else if (resource.type === "test") {
      const attemptType = resource?.examType === "writing"
        ? "writingTestAttempt"
        : resource?.examType === "speaking"
          ? "speakingTestAttempt"
          : "testAttempt";
      navigate(
        `/student/myClassrooms/${classroomId}/${topic.subjectId}/${topic.id}/test/${attemptType}/${resource.id}`
      );
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="diagnostic-container">
      {/* Navigation Tabs */}
      <div className="diagnostic-tabs">
        <button
          className={`tab-button ${
            activeSection === "mastery" ? "active" : ""
          }`}
          onClick={() => setActiveSection("mastery")}
        >
          Topics Near Champion Level
        </button>
        <button
          className={`tab-button ${activeSection === "growth" ? "active" : ""}`}
          onClick={() => setActiveSection("growth")}
        >
          Growth Progress
        </button>
      </div>

      <SubjectFilter
        subjects={subjects}
        filteredSubjects={filteredSubjects}
        handleFilterChange={handleFilterChange}
      />

      {activeSection === "mastery" && (
        <>
          {/* <TopicsNearMastery
            topicsNearMastery={topicsNearMastery}
            handleResourceClick={handleResourceClick}
            studentId={studentId}
          /> */}
          <RecommendationsGuide />
          <Recommendations
            recommendations={recommendations}
            handleResourceClick={handleResourceClick}
          />
        </>
      )}

      {activeSection === "growth" && (
        <GrowthProgress
          filteredGrowthData={filteredGrowthData}
          studentId={studentId}
        />
      )}
    </div>
  );
};

export default memo(Diagnostic);
